import React , { useState , useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Collapse , Input , CardBody } from 'reactstrap'
import { add_to_selected_column, add_to_selected_column_payload, change_column_alias, remove_from_selected_column, remove_from_selected_column_payload, update_vector_column_distinct_selection } from '../../../../slices/Table_Details/reducer'
import { useSelector } from 'react-redux'
const Column_List = ({ coll6 , column , table_select , table_name , pre_selected, select_all_column , setselect_all_column }) => {
    
    const { selectedColumns , removedColumns ,Changed_Column_alias } = useSelector((state)=> state.Table_Details)
    const [column_select, setcolumn_select] = useState(false)
    const [pre_selected_table, setpre_selected_table] = useState(false)
    const [column_alias, setcolumn_alias] = useState( Changed_Column_alias[`${table_name}//${column.column_name}`]|| column.column_alias)
    const [initaila_render, setinitaila_render] = useState(true)
    const [extract_distict, setextract_distict] = useState(false)
    const { vector_column_distinct_selection } = useSelector((state)=> state.Table_Details)
    const dispatch = useDispatch()


useEffect(() => {
      
    setpre_selected_table(pre_selected)
     
}, [])

useEffect(() => {
       
let value_1 = false
let value_2 = false
    value_1 = column.vector_column_distinct
    value_2 = vector_column_distinct_selection[column.column_name]?.distinct_extraction
   if(value_1 || value_2){
    setextract_distict(true)
}

}, [table_name])

    



 


    useEffect(() => {
           
         
        if(pre_selected_table){

            
            
            
            

        

            if(table_select && column.column_selected && (!removedColumns.includes(`${table_name}//${column.column_name}`)) ){
                dispatch(add_to_selected_column(`${table_name}//${column.column_name}`))
                setcolumn_select(true)
            }

            setpre_selected_table(false)

        }else{

         
           

            if(table_select && (!removedColumns.includes(`${table_name}//${column.column_name}`)) ){
                dispatch(add_to_selected_column(`${table_name}//${column.column_name}`))
                setcolumn_select(true)
            }

           
            // else{

            //     if(selectedColumns.includes(`${table_name}//${column.column_name}`)){
                    
            //         dispatch(remove_from_selected_column(`${table_name}//${column.column_name}`))
            //     }
            // }

        }


           
        
      
    }, [table_select ])

    



        useEffect(() => {
         
            

            if(selectedColumns.includes(`${table_name}//${column.column_name}`)){
                setcolumn_select(true )
        
            }
            if(removedColumns.includes(`${table_name}//${column.column_name}`)){
              
                setcolumn_select(false)
            }
              
            
             
        }, [selectedColumns, removedColumns])


        // useEffect(() => {
         
        //     if(removedColumns.includes(`${table_name}//${column.column_name}`) || pre_selected_table ){
             
        //         setselect_all_column(false)
        //     }

        
        // }, [])


        useEffect(() => {
            // console.log(pre_selected)
            if(!initaila_render){
            if(!select_all_column){
                
                
                dispatch(remove_from_selected_column(`${table_name}//${column.column_name}`))
                dispatch(remove_from_selected_column_payload({ table_name , column_name:column.column_name }))
            
                setcolumn_select(false)
            }
            else if(select_all_column){
                dispatch(remove_from_selected_column(`${table_name}//${column.column_name}`))
                dispatch(remove_from_selected_column_payload({ table_name , column_name:column.column_name }))
               
        dispatch(add_to_selected_column(`${table_name}//${column.column_name}`))
        dispatch(add_to_selected_column_payload({ table_name , column_name:column.column_name , type:column.column_data_type , vector_column_distinct:extract_distict }))
                setcolumn_select(true)
            }
        }
        else{
               setinitaila_render(false)
        }
        }, [select_all_column, setselect_all_column])
        


        




    


     
        
            

    


    const onAdd_Column =()=>{
        dispatch(add_to_selected_column(`${table_name}//${column.column_name}`))
        dispatch(add_to_selected_column_payload({ table_name , column_name:column.column_name , type:column.column_data_type }))
    } 


    const onRemove_Column =()=>{
        dispatch(remove_from_selected_column(`${table_name}//${column.column_name}`))
        dispatch(remove_from_selected_column_payload({ table_name , column_name:column.column_name }))
    }



    const on_Change_Column_alias = (e)=>{
        if(selectedColumns.includes(`${table_name}//${column.column_name}`)){

            setcolumn_alias(e.target.value)
      
         dispatch(change_column_alias({ table_name ,column_name:column.column_name, column_alias:e.target.value   }))
        }
    }

 const on_Change_Extarct_Distinct = (e)=>{
    setextract_distict(e.target.checked)
    dispatch(update_vector_column_distinct_selection({
        column_name:column.column_name , 
        distinct_extraction:e.target.checked
    }))
 
        dispatch(remove_from_selected_column_payload({ table_name , column_name:column.column_name }))
        dispatch(add_to_selected_column_payload({ table_name , column_name:column.column_name , type:column.column_data_type,vector_column_distinct:e.target.checked }))    
  
   
 }
    
    
  return (

                                    <div className={`alis  ${column_select?'bg-color-inner':''}`}>
                                        <div className="typm">
                                            <div className='check_container'>
                                                <div class="form-check form-check-outline form-check-primary">
                                                    <Input disabled={!table_select} onChange={(e)=>{
                                                        
                                                        
                                                        if(table_select){

                                                            setcolumn_select(e.target.checked)
                                                        }
                                            if(e.target.checked){
                                               onAdd_Column()
                                            }else{
                                               onRemove_Column()
                                            }
                                        }} checked={column_select} 
                                         
                                    
                                        
                                        class="form-check-input" type="checkbox" id="formCheck13"  />
                                                </div>
                                            </div>
                                            <div className='type_container'>
                                                <span>{column.column_name}</span>
                                            </div>
                                        </div>
                                       <div className='edd'>                                       
                                       <Input checked={extract_distict} disabled={ !table_select || !column_select} class="form-check-input" type="checkbox" id="formCheck14" style={{marginRight:'5px'}} onChange={on_Change_Extarct_Distinct} /> Extract Distinct Data
                                       </div>
                                        <div className="atm_input">
                                        <Input value={column_alias} onChange={on_Change_Column_alias} type="Text" class="form-control" id="basiInput" placeholder={column.column_name}/>
                                        </div>                    
                                    </div>                              
                      
  )
}

export default Column_List